import 'hammerjs';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';

import { DemoMaterialModule } from '../demo-material-module';
import { CdkTableModule } from '@angular/cdk/table';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';

import { MaterialRoutes } from './material.routing';
import { ButtonsComponent } from './buttons/buttons.component';

import { GridComponent } from './grid/grid.component';
import { ListsComponent } from './lists/lists.component';
import { MenuComponent } from './menu/menu.component';
import { TabsComponent } from './tabs/tabs.component';
import { StepperComponent } from './stepper/stepper.component';
import { ExpansionComponent } from './expansion/expansion.component';
import { ChipsComponent } from './chips/chips.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { ProgressSnipperComponent } from './progress-snipper/progress-snipper.component';
import { ProgressComponent } from './progress/progress.component';
import {
  DialogComponent,
  DialogOverviewExampleDialogComponent
} from './dialog/dialog.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { SnackbarComponent } from './snackbar/snackbar.component';
import { SliderComponent } from './slider/slider.component';
import { SlideToggleComponent } from './slide-toggle/slide-toggle.component';
import { ProfileComponent } from './profile/profile.component';
import { UserComponent } from './user/user.component';
import { UserDialogComponent } from './user/user-dialog/user-dialog.component';
import { NotificationComponent } from './notification/notification.component';
import { CutiComponent } from './cuti/cuti.component';
import { RegulasiComponent } from './regulasi/regulasi.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { MainProfileComponent } from './main-profile/main-profile.component';
import { FormCutiComponent } from './cuti/form-cuti/form-cuti.component';
import { PreviewComponent } from './preview/preview.component';
import { FormasiComponent } from './formasi/formasi.component';
import { AlarmPegawaiComponent } from './alarm-pegawai/alarm-pegawai.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { RiwayatProfileComponent } from './riwayat-profile/riwayat-profile.component';
import { FormRiwayatProfileComponent } from './riwayat-profile/form-riwayat-profile/form-riwayat-profile.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ApprovalComponent } from './riwayat-profile/approval/approval.component';
import { ApprovalDialogComponent } from './riwayat-profile/approval/approval-dialog/approval-dialog.component';
import { TrComponent } from './tr/tr.component';
import { FormRegulasiComponent } from './regulasi/form-regulasi/form-regulasi.component';
import { RiwayatProgressComponent } from './riwayat-progress/riwayat-progress.component';
import { InfoCutiComponent } from './cuti/info-cuti/info-cuti.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(MaterialRoutes),
    DemoMaterialModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    CdkTableModule,
    NgxExtendedPdfViewerModule,
  ],
  providers: [],
  entryComponents: [DialogOverviewExampleDialogComponent],
  declarations: [
    ButtonsComponent,
    GridComponent,
    ListsComponent,
    MenuComponent,
    TabsComponent,
    StepperComponent,
    ExpansionComponent,
    ChipsComponent,
    ToolbarComponent,
    ProgressSnipperComponent,
    ProgressComponent,
    DialogComponent,
    DialogOverviewExampleDialogComponent,
    TooltipComponent,
    SnackbarComponent,
    SliderComponent,
    SlideToggleComponent,
    ProfileComponent,
    UserComponent,
    UserDialogComponent,
    NotificationComponent,
    CutiComponent,
    RegulasiComponent,
    ConfirmDialogComponent,
    MainProfileComponent,
    FormCutiComponent,
    PreviewComponent,
    FormasiComponent,
    AlarmPegawaiComponent,
    NotFoundComponent,
    RiwayatProfileComponent,
    FormRiwayatProfileComponent,
    ApprovalComponent,
    ApprovalDialogComponent,
    TrComponent,
    FormRegulasiComponent,
    RiwayatProgressComponent,
    InfoCutiComponent,
  ],
  exports: [TrComponent],
})
export class MaterialComponentsModule { }
